import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function getStatusColor(status) {
    // eslint-disable-next-line default-case
    switch (status) {
        case 'Pending Request':
            return 'text-yellow-900 bg-yellow-100';
        case 'Pending Approval':
            return 'text-blue-800 bg-blue-100';
        case 'Rejected':
            return 'text-red-900 bg-red-100';
        case 'Needs Updates':
            return 'text-yellow-900 bg-yellow-100';
        case 'Pending Recommendation':
            return 'text-blue-900 bg-blue-200';
        case 'Report Ready':
            return 'text-green-800 bg-green-100';
        case 'Report Received':
            return 'text-green-900 bg-green-200';
    }
}
function getStatusDisplayName(status, statusDisplayNameOverride) {
    if (!statusDisplayNameOverride)
        return status;
    return statusDisplayNameOverride[status] || status;
}
function RequestStatusPill(_a) {
    var status = _a.status, statusDisplayNameOverride = _a.statusDisplayNameOverride, _b = _a.testSelector, testSelector = _b === void 0 ? 'request-status-pill' : _b;
    return (_jsx("span", { "data-cy": testSelector, className: clsx('inline-flex px-2 text-xs font-semibold leading-5 rounded-full', getStatusColor(status)), "data-public": "true", children: getStatusDisplayName(status, statusDisplayNameOverride) }));
}
export default RequestStatusPill;
